// extracted by css-extract-rspack-plugin
export default {"frame":"_2b8f09b4","frameCompactResp":"_b5a9c567","frameMobile":"_4c3d84b4","frameCompactMobile":"_34174a73","viewAllTile":"_ac5711b1"};